import { JS_OBJECT, PRIMITIVE_JS_VALUE, IMMUTABLE_MAP, IMMUTABLE_SET, IMMUTABLE_MAP_OF_LAYOUT_TREES, IMMUTABLE_MAP_OF_GRID_LAYOUT_TREES, NestedImmutableMap, IMMUTABLE_LIST, ALLOWLISTED_SCHEMA_OBJECT, NestedJsObject
// @ts-expect-error module not migrated yet
} from 'ContentEditorUI/redux/inpageSync/types';
import emailBasicSyncConfig from './emailBasicSyncConfig';

/**
 * Config describing which slices of app state to sync with the inpage app
 * and any transformations or special handling that should be applied
 */

export default (() => Object.assign({}, emailBasicSyncConfig, {
  contentModel: NestedJsObject({
    themeSettingsValues: JS_OBJECT,
    id: PRIMITIVE_JS_VALUE,
    language: PRIMITIVE_JS_VALUE,
    aiFeatures: JS_OBJECT
  }),
  contentSchema: ALLOWLISTED_SCHEMA_OBJECT,
  extraInitialState: JS_OBJECT,
  inpageData: NestedJsObject({
    highlightedWidgetId: PRIMITIVE_JS_VALUE,
    html: PRIMITIVE_JS_VALUE,
    htmlBody: PRIMITIVE_JS_VALUE,
    inpageMode: PRIMITIVE_JS_VALUE,
    isDraggingModule: PRIMITIVE_JS_VALUE,
    scrollToModuleId: PRIMITIVE_JS_VALUE,
    computedStylesBySelector: JS_OBJECT,
    previewViewportDimensions: JS_OBJECT
  }),
  modules: {
    immutable: true,
    allowlist: ['present', 'redoCount', 'undoCount'],
    nestedConfig: {
      redoCount: PRIMITIVE_JS_VALUE,
      undoCount: PRIMITIVE_JS_VALUE,
      present: NestedImmutableMap({
        uneditableWidgets: IMMUTABLE_MAP,
        schemaLayoutSectionTrees: IMMUTABLE_MAP_OF_LAYOUT_TREES,
        layoutSectionTrees: IMMUTABLE_MAP_OF_LAYOUT_TREES,
        flexAreaTree: IMMUTABLE_MAP_OF_LAYOUT_TREES,
        gridLayoutTrees: IMMUTABLE_MAP_OF_GRID_LAYOUT_TREES,
        schemaGridLayoutTrees: IMMUTABLE_MAP_OF_GRID_LAYOUT_TREES,
        schemaGridLayoutWidgets: IMMUTABLE_MAP,
        layoutSectionWidgets: IMMUTABLE_MAP,
        schemaWidgetContainers: IMMUTABLE_MAP,
        widgetContainers: IMMUTABLE_MAP,
        schemaWidgets: IMMUTABLE_MAP,
        fakeModules: IMMUTABLE_MAP,
        widgets: IMMUTABLE_MAP,
        contentCss: IMMUTABLE_MAP,
        moduleMetaData: IMMUTABLE_MAP,
        widgetsInRichText: IMMUTABLE_MAP,
        clonedModulesPendingDomOperations: IMMUTABLE_SET,
        themePageOverrides: JS_OBJECT,
        // email only
        flexAreaSections: IMMUTABLE_LIST,
        flexAreaStyles: IMMUTABLE_MAP,
        flexAreaStyleSettings: IMMUTABLE_MAP,
        userModuleDefaults: IMMUTABLE_MAP,
        sidebarTree: IMMUTABLE_MAP
      })
    }
  },
  portalSettings: JS_OBJECT,
  sidebarState: {
    immutable: false,
    exportBeforeMessageSent: valueToExport => {
      return Object.assign({}, valueToExport, {
        // Reinitialize closedTreeNodes and dndAreasThatShowAllRows as native
        // Sets since Immer produced Set values are not serializable in Safari.
        // See https://git.hubteam.com/HubSpot/ContentEditorUI/pull/18404 for
        // more context.
        closedTreeNodes: new Set(valueToExport.closedTreeNodes),
        dndAreasThatShowAllRows: new Set(valueToExport.dndAreasThatShowAllRows)
      });
    }
  },
  templateInfo: JS_OBJECT,
  theme: IMMUTABLE_MAP,
  paymentsEligibility: JS_OBJECT,
  // Custom in DND
  savedSections: JS_OBJECT,
  socialNetworks: JS_OBJECT
}));